var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tooltip",class:{
    'ui-tooltip--enabled': !_vm.pDisabled
  }},[_vm._t("default"),_c('div',{staticClass:"ui-tooltip__title-host",class:_vm.placement},[_c('div',{staticClass:"ui-tooltip__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }